import { Reducer } from 'redux';

import { KeyResultI } from '../keyResultStream/interfaces';
import { ThunkFailAction, ThunkSuccessAction } from '../../../services/apiMiddleware';

import {
  createKeyResultTypes,
  deleteKeyResultTypes,
  editKeyResultTypes,
  fetchKeyResultsTypes,
  updateKeyResultType,
} from './actionTypes';

export interface KeyResultSessionState {
  loadingKeyResults: boolean;
  loadingCreation: boolean;
  keyResults?: KeyResultI[];
}

export function getInitialKeyResultsState(): KeyResultSessionState {
  return {
    loadingKeyResults: false,
    loadingCreation: false,
  };
}

const editKeyResult = (state: KeyResultSessionState, action: ThunkSuccessAction | ThunkFailAction) => {
  const keyResultsCopy = [...(state.keyResults || [])];
  const editedKeyResult = action.response.data;
  if (keyResultsCopy) {
    const foundIndex = keyResultsCopy.findIndex(stateKeyResult => stateKeyResult.id === editedKeyResult.id);
    if (foundIndex !== -1) {
      keyResultsCopy[foundIndex] = { ...keyResultsCopy[foundIndex], ...editedKeyResult };
    }
    return keyResultsCopy;
  }
  return [editedKeyResult];
};

const keyResultReducer: Reducer<KeyResultSessionState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialKeyResultsState(),
  action,
) => {
  switch (action.type) {
    case fetchKeyResultsTypes.Request:
      return { ...state, loadingKeyResults: true };
    case fetchKeyResultsTypes.Success:
      return { ...state, loadingKeyResults: false, keyResults: action.response.data };
    case fetchKeyResultsTypes.Failed:
      return { ...state, loadingKeyResults: false };
    case createKeyResultTypes.Request:
      return { ...state, loadingCreation: true };
    case createKeyResultTypes.Success:
      return {
        ...state,
        loadingCreation: false,
        keyResults: [action.response.data, ...(state.keyResults || [])],
      };
    case createKeyResultTypes.Failed:
      return { ...state, loadingCreation: false };
    case editKeyResultTypes.Success:
    case updateKeyResultType.Success:
      return { ...state, keyResults: editKeyResult(state, action) };
    case deleteKeyResultTypes.Success:
      return {
        ...state,
        keyResults: state.keyResults
          ? state.keyResults.filter(kr => kr.id !== action.keyResultId)
          : undefined,
      };
    default:
      return state;
  }
};

export default keyResultReducer;
